import { queryOptions, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  dynamicLinksClient,
  type CreateDynamicLinkPayload,
  type DynamicLinksListParams,
} from "api/clients/dynamicLinks";

const DYNAMIC_LINKS_LIST = "DYNAMIC_LINKS_LIST";
const dynamicLinksListKey = [DYNAMIC_LINKS_LIST];

export const dynamicLinksQueryOptions = (params: DynamicLinksListParams) =>
  queryOptions({
    queryKey: [DYNAMIC_LINKS_LIST, params],
    queryFn: () => dynamicLinksClient.list(params),
  });

export const useCreateDynamicLink = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: CreateDynamicLinkPayload) => dynamicLinksClient.create(payload),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: dynamicLinksListKey }),
  });
};

export const useUpdateDynamicLink = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...payload }: Partial<CreateDynamicLinkPayload> & { id: number }) =>
      dynamicLinksClient.update(id, payload),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: dynamicLinksListKey }),
  });
};

export const useDeleteDynamicLink = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => dynamicLinksClient.delete(id),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: dynamicLinksListKey }),
  });
};
